import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../topic/redux/actions';
import StyleTwoSectionTitle from './StyleTwoSectionTitle'

export class StyleTwoCommonQuestion extends Component {
  static propTypes = {
    topic: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {
    let { itemsData, colorData } = this.props;
    return (
      <div className="topic-style-two-common-question">
        <a name={itemsData.name}><StyleTwoSectionTitle isColorW={false} Data={itemsData} /></a>
        <div className='common_problem_list'>
          {itemsData.list && itemsData.list.map(item => <div className='common_problem_item' key={item.id}>
            <div className='common_problem_item_title flex_row' style={{ backgroundColor: `${colorData.opacityColor006}`, color: `${colorData.color}`}}>
              <div className='common_problem_rank flex_row'>{item.id}.</div>
              <div>{item.title}</div>
            </div>
            <div className='common_problem_item_content'>
              {item.contentList && item.contentList.map(_item => <div dangerouslySetInnerHTML={{ __html: _item.content }} key={_item.id}></div>)}
            </div>
          </div>)}
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    topic: state.topic,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StyleTwoCommonQuestion);



// WEBPACK FOOTER //
// ./src/features/style-two/StyleTwoCommonQuestion.js